/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { BuilderSharedModule } from '@gh/builder-shared';
import { CoreUiExtSplitPaneModule } from '@gh/core-ui-ext/split-pane';

import { CoreUiDragulaModule } from '@gh/core-ui/dragula';

import { BuilderSalesRoutingModule } from './builder-sales-routing.module';
import { EmailCampaignReportDialogComponent } from './email-campaigns/components/email-campaign-report-dialog/email-campaign-report-dialog.component';
import { EmailCampaignDetailsBusinessService } from './email-campaigns/resources/email-campaign-details-business.service';
import { EmailCampaignListBusinessService } from './email-campaigns/resources/email-campaign-list-business.service';
import {
  ApprovedQuotesDialogComponent,
  CompleteSaleAuthorizationStepComponent,
  CompleteSaleChecklistStepComponent,
  CompleteSaleDialogComponent,
  CompleteSaleQuotesStepComponent,
  JobDppCreateDialogComponent,
  LeadBoardBusinessService,
  LeadBoardCardComponent,
  LeadBoardCardMoveDialogComponent,
  LostLeadReasonDialogComponent,
  LeadBoardColumnComponent,
  LeadBoardComponent,
  LeadBoardContainerComponent,
  LeadBoardMobileContainerComponent,
  LeadBoardPanelComponent,
  LeadCardHeightStrategyDirective,
  LeadDetailsBusinessService,
  LeadDetailsCommunicationListComponent,
  LeadDetailsDcTabComponent,
  LeadDetailsSfContentComponent,
  LeadDetailsSfFormComponent,
  LeadDetailsSfTabComponent,
  LeadDetailsTabContainerComponent,
  LeadDetailsTopFormComponent,
  LeadListBusinessService,
  LeadListComponent,
  QuoteCloneDataDialogComponent,
  QuoteDetailsBottomPanelComponent,
  QuoteDetailsBusinessService,
  QuoteDetailsComponent,
  QuoteDetailsTopFormComponent,
  QuoteDetailsVariationListComponent,
  QuoteStructureDetailItemComponent,
  QuoteStructureDetailsDialogComponent,
  QuoteStructureDialogComponent,
  QuoteStructureHeadingComponent,
  QuoteTopDialogComponent,
  RfqGeneralTabComponent,
  RfqQuoteFilterDialogComponent,
  RfqTabContainerComponent,
  VirtualItemComponent,
  VirtualListComponent,
  VirtualListForDirective,
  VirtualViewportDirective,
} from './leads';
import { VirtualDndItemDirective } from './leads/components/lead-board/virtual-dnd/virtual-dnd-item.directive';
import { VirtualDndViewportPreviewDirective } from './leads/components/lead-board/virtual-dnd/virtual-dnd-viewport-preview.directive';
import { VirtualDndViewportDirective } from './leads/components/lead-board/virtual-dnd/virtual-dnd-viewport.directive';
import { VirtualDndZoneDirective } from './leads/components/lead-board/virtual-dnd/virtual-dnd-zone.directive';
import { LeadDetailsReassignDialogComponent } from './leads/components/lead-details/lead-details-reassign-dialog/lead-details-reassign-dialog.component';
import { SalesManagementReportFilterDialogComponent } from './leads/components/lead-list/sales-management-report-filter-dialog/sales-management-report-filter-dialog.component';
import { RfqEDocListTabComponent } from './leads/components/rfq/rfq-e-doc-list-tab/rfq-e-doc-list-tab.component';
import { RfqQuotationListTabComponent } from './leads/components/rfq/rfq-quotation-list-tab/rfq-quotation-list-tab.component';
import { RfqSitesTabComponent } from './leads/components/rfq/rfq-site-list-tab/rfq-site-list-tab.component';
import { RfqSiteDetailsComponent } from './leads/components/site-details/rfq-site-details.component';
import { QuoteStructureBusinessService } from './leads/resources/quote-structure-business.service';
import { RfqBusinessService } from './leads/resources/rfq-business.service';
import { SiteDetailsBusinessService } from './leads/resources/site-details-business.service';
import {
  SalespersonBudgetListBusinessService,
  SalespersonBudgetListComponent,
} from './salesperson-budgets';
import { RfqManagementListComponent } from './rfq-management/components/rfq-management-list/rfq-management-list.component';
import { RfqManagementListBusinessService } from './rfq-management/resources/rfq-management-list-business.service';
import { QuoteDetailsDialogComponent } from './rfq-management/components/quote-details-dialog/quote-details-dialog.component';
import { HlpListBusinessService } from './hlp/resources/hlp-list-business.service';
import { HlpListComponent } from './hlp/components/hlp-list/hlp-list.component';
import { HlpDetailsTabContainerComponent } from './hlp/components/hlp-details/hlp-details-tab-container.component';
import { HlpDetailsBusinessService } from './hlp/resources/hlp-details-business.service';
import {
  HlpDetailsCommonTabComponent,
} from './hlp/components/hlp-details/hlp-details-common-tab/hlp-details-common-tab.component';
import {
  HlpDetailsDesignTabComponent,
} from './hlp/components/hlp-details/hlp-details-design-tab/hlp-details-design-tab.component';

import {
  HlpQuoteDetailsTopFormComponent,
} from './hlp/components/hlp-details/hlp-details-quote-tab/hlp-quote-details-top-form/hlp-quote-details-top-form.component';
import { HlpDetailsQuoteTabComponent } from './hlp/components/hlp-details/hlp-details-quote-tab/hlp-details-quote-tab.component';
import {
  HlpQuoteDetailsVariationListComponent,
} from './hlp/components/hlp-details/hlp-details-quote-tab/hlp-quote-details-variation-list/hlp-quote-details-variation-list.component';
import {
  HlpQuoteDetailsBottomPanelComponent,
} from './hlp/components/hlp-details/hlp-details-quote-tab/hlp-quote-details-bottom-panel/hlp-quote-details-bottom-panel.component';
import { HlpCreateLeadQuoteDialogComponent } from './hlp/components/hlp-create-lead-quote-dialog/hlp-create-lead-quote-dialog.component';
import { RfqSiteMapDialogComponent } from './leads/components/site-details/rfq-site-map-dialog.component';
import { BulkEditLeadsDialogComponent } from './leads/components/bulk-edit-leads-dialog/bulk-edit-leads-dialog.component';
import { OfficeBulkReassignLeadsDialogComponent } from './leads/components/office-bulk-reassign-leads-dialog/office-bulk-reassign-leads-dialog.component';

@NgModule({
  imports: [
    CoreUiDragulaModule,
    BuilderSharedModule.forChild(),
    CoreUiExtSplitPaneModule,
    BuilderSalesRoutingModule,
  ],
  providers: [
    LeadListBusinessService,
    LeadDetailsBusinessService,
    SalespersonBudgetListBusinessService,
    RfqBusinessService,
    RfqManagementListBusinessService,
    SiteDetailsBusinessService,
    QuoteDetailsBusinessService,
    QuoteStructureBusinessService,
    EmailCampaignListBusinessService,
    EmailCampaignDetailsBusinessService,
    LeadBoardBusinessService,
    HlpListBusinessService,
    HlpDetailsBusinessService,
  ],
  declarations: [
    LeadListComponent,
    BulkEditLeadsDialogComponent,
    OfficeBulkReassignLeadsDialogComponent,
    LeadDetailsTabContainerComponent,
    LeadDetailsDcTabComponent,
    LeadDetailsSfTabComponent,
    LeadDetailsSfContentComponent,
    LeadDetailsSfFormComponent,
    LeadDetailsTopFormComponent,
    LeadDetailsCommunicationListComponent,
    SalespersonBudgetListComponent,
    LeadDetailsReassignDialogComponent,
    RfqTabContainerComponent,
    RfqSitesTabComponent,
    RfqGeneralTabComponent,
    RfqQuotationListTabComponent,
    RfqSiteDetailsComponent,
    RfqEDocListTabComponent,
    QuoteDetailsComponent,
    QuoteDetailsTopFormComponent,
    QuoteDetailsVariationListComponent,
    QuoteDetailsBottomPanelComponent,
    QuoteCloneDataDialogComponent,
    QuoteStructureDialogComponent,
    QuoteStructureHeadingComponent,
    QuoteStructureDetailItemComponent,
    QuoteStructureDetailsDialogComponent,
    QuoteTopDialogComponent,
    RfqQuoteFilterDialogComponent,
    ApprovedQuotesDialogComponent,
    CompleteSaleDialogComponent,
    CompleteSaleQuotesStepComponent,
    CompleteSaleChecklistStepComponent,
    CompleteSaleAuthorizationStepComponent,
    JobDppCreateDialogComponent,
    EmailCampaignReportDialogComponent,
    SalesManagementReportFilterDialogComponent,
    LeadBoardContainerComponent,
    LeadBoardMobileContainerComponent,
    LeadBoardPanelComponent,
    LeadBoardColumnComponent,
    LeadBoardCardComponent,
    LeadBoardComponent,
    LeadBoardCardMoveDialogComponent,
    LostLeadReasonDialogComponent,
    VirtualViewportDirective,
    VirtualListComponent,
    VirtualListForDirective,
    VirtualItemComponent,
    LeadCardHeightStrategyDirective,
    VirtualDndItemDirective,
    VirtualDndViewportDirective,
    VirtualDndViewportPreviewDirective,
    VirtualDndZoneDirective,
    RfqManagementListComponent,
    QuoteDetailsDialogComponent,
    HlpListComponent,
    HlpDetailsTabContainerComponent,
    HlpDetailsCommonTabComponent,
    HlpDetailsDesignTabComponent,
    HlpDetailsQuoteTabComponent,
    HlpQuoteDetailsTopFormComponent,
    HlpQuoteDetailsVariationListComponent,
    HlpQuoteDetailsBottomPanelComponent,
    HlpCreateLeadQuoteDialogComponent,
    RfqSiteMapDialogComponent,
  ],
  schemas: [ NO_ERRORS_SCHEMA ],
})
export class BuilderSalesModule {
}
